<template>
  <div class="notification-list-container">
    <el-empty v-if="!notifications.length && !loading" description="暂无通知"></el-empty>
    
    <el-skeleton v-if="loading" :rows="3" animated />
    
    <div v-else class="notification-list">
      <div 
        v-for="notification in notifications" 
        :key="notification.id"
        :class="['notification-item', { 'unread': notification.isRead === 0 }]"
      >
        <div class="notification-header">
          <div 
            :class="['notification-icon', notification.businessType.toLowerCase()]"
          >
            <i :class="getIconClass(notification.businessType)"></i>
          </div>
          <div class="notification-info">
            <div class="notification-title">{{ notification.title }}</div>
            <div class="notification-time">{{ formatDate(notification.createTime) }}</div>
          </div>
        </div>
        
        <div class="notification-content">{{ notification.content }}</div>
        
        <div class="notification-actions">
          <el-button 
            v-if="notification.isRead === 0"
            type="text"
            size="mini"
            @click="$emit('mark-read', notification.id)"
          >标记为已读</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationList',
  props: {
    notifications: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      
      const now = new Date();
      const date = new Date(timestamp);
      const diff = Math.floor((now - date) / 1000);
      
      if (diff < 60) {
        return '刚刚';
      } else if (diff < 3600) {
        return `${Math.floor(diff / 60)}分钟前`;
      } else if (diff < 86400) {
        return `${Math.floor(diff / 3600)}小时前`;
      } else if (diff < 2592000) {
        return `${Math.floor(diff / 86400)}天前`;
      } else {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      }
    },
    getIconClass(type) {
      switch (type) {
        case 'APPOINTMENT':
          return 'el-icon-date';
        case 'EXPIRATION':
          return 'el-icon-warning';
        case 'PROMOTION':
          return 'el-icon-goods';
        default:
          return 'el-icon-message';
      }
    }
  }
};
</script>

<style>
.notification-list-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 0 10px;
}

.notification-list {
  padding: 10px 0;
}

.notification-item {
  padding: 12px;
  margin-bottom: 10px;
  border-radius: 4px;
  background-color: #f8f8f8;
  transition: all 0.3s;
  cursor: pointer;
}

.notification-item:hover {
  background-color: #f2f2f2;
}

.notification-item.unread {
  background-color: #ecf5ff;
  border-left: 3px solid #409eff;
}

.notification-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.notification-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  background-color: #909399;
  color: white;
}

.notification-icon.appointment {
  background-color: #409eff;
}

.notification-icon.expiration {
  background-color: #e6a23c;
}

.notification-icon.promotion {
  background-color: #67c23a;
}

.notification-info {
  flex: 1;
}

.notification-title {
  font-weight: bold;
  margin-bottom: 4px;
}

.notification-time {
  font-size: 12px;
  color: #909399;
}

.notification-content {
  margin-bottom: 10px;
  color: #606266;
  word-break: break-word;
}

.notification-actions {
  text-align: right;
}
</style> 